import React, { useState, useEffect, useMemo } from "react";
import TNButton from "../../../../../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonSize,
  ButtonType,
} from "../../../../../../enums/ButtonAttributesEnums";
import {
  Drawer,
  Row,
  Col,
  Select,
  Modal,
  message,
  notification,
  Checkbox,
} from "antd";
import BidToolForm from "../BidToolForm";
import backButton from "../../../../../../assets/images/back-button.svg";
import { useFormContext } from "react-hook-form";
import styles from "./AddTruckOrdersForm.module.scss";
import {
  AddTruckFormProps,
  BidToolStyles,
  buttonOptionsProps,
  CancelStyles,
  DrawerHeaderBidToolStyles,
  sampleProjectSummaryBody,
  sampleProjectSummaryHeader,
  SubmitStyles,
  getTruckOptions,
  getMaterialOptions,
  truckDetaildFormKeys,
  BidToolFromKeys,
  truckVendorDetailKeys,
  sampletProjectSummaryBodyMaterial,
  buttonOptionsKeys,
  SEARCH_FILTER_TYPE,
  getMaterialPriceFromMargin,
  getMarginPercentFromMaterialPrice,
  negativeMarkupModalProps,
  checkboxConstants,
} from "./constants";
import {
  getPrevDollorFormattedString,
  getPostPercentFormattedString,
} from "../../../../../../Utilities";
import ConditionalRender from "../../../../../../reusable-components/ConditionalRender";
import InputField from "../../../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../../../enums/InputFieldAttributesEnums";
import TNGoogleAddressSuggestions from "../../../../../../reusable-components/TNGoogleSearch";
import { DropdownOptionsPayload } from "../../../../../../models/DropdownOptionsPayload/dropdownOptionsPayload";
import CreateJobServices from "../../../../../../services/createJob.services";
import { useTruckDetailContext } from "../../../../../../context/TruckDetailsContext";
import { AddTruckType } from "../../../../../../enums/AddTruckType";
import { useMaterials } from "../../../../../../context/materialListingContext";
import { TruckDataListing } from "../../../../../../models/TruckDetailListing/truckDetailListing.model";
import clsx from "clsx";
import { duration } from "moment";
import {
  CheckboxType,
  TruckMaterialType,
} from "../../../../../../enums/truckMaterialType";
import { useQueryClient } from "@tanstack/react-query";
import { useTruckMaterialFormFlowContext } from "../../../../../../context/TruckMaterialFormFlowContext";
import { QuarryData } from "../../../../../../Types";
import {
  stripCurrencyFormatting,
  thousandsSeparator,
  thousandsSeparatorForCurrency,
} from "../../../../../../Utilities/regex";
import { DOLLAR_PREFIX } from "../../../../../BidToolConfigurationView/constants";
import { formatNumber } from "../../../../../../utils/numberFormatterUtil";
import { allowedKeys } from "../../../../../../constants/keyboardKeys";
import { v4 as uuidv4 } from "uuid";

interface AddTruckFormProps {
  topQuariesOuterData?: QuarryData;
  topQuariesMaterialData?: QuarryData;
  materialDrawerClose?: () => void;
  onClose: () => void;
  dropdownData?: DropdownOptionsPayload;
  flowType?: string;
  vendorMaterialCost?: number;
  venodorMaterialUnit?: string;
  dropOffMatCoords?: string;
  pickupMatCoords?: string;
  leadId?: string;
  editData?: MaterialTruck;
  presetDropLocation?: string;
  presetDropCoordinates?: string;
  truckFormType?: AddTruckType;
}

const AddTruckOrdersForm = ({
  dropOffMatCoords,
  pickupMatCoords,
  leadId,
  topQuariesOuterData,
  topQuariesMaterialData,
  materialDrawerClose,
  vendorMaterialCost,
  venodorMaterialUnit,
  onClose,
  dropdownData,
  presetDropCoordinates,
  presetDropLocation,
  truckFormType,
}: AddTruckFormProps) => {
  const {
    TRUCK_TYPE_ERROR_MSG,
    BID_TOOL_BTN_TEXT,
    DRAWER_HEADER,
    TRUCK_TYPE_HEADER,
    JOB_DETAILS_HEADER,
    ESTIMATED_QUANTITY_HEADER,
    TRUCK_PRICE_HEADER,
    PROJECT_SUMMARY_HEADER,
    CANCEL_BTN_TXT,
    SUBMIT_BTN_TXT,
    PER_UNIT_TXT,
    PERCENT_SALES_TXT,
    PROJECT_TXT,
    REVENUE_TXT,
    COGS_TXT,
    GROSS_PROFIT_TXT,
    TAB_FIELD_NAME,
    TON_TXT,
    HOUR_TXT,
    YARD_TXT,
    LOAD_TXT,
    PICKUP_LOCATION_LABEL,
    PICKUP_LOCATION_NAME,
    PICKUP_LOCATION_PLACEHOLDER,
    PICKUP_LOCATION_COORDS_LABEL,
    PICKUP_LOCATION_COORDS_NAME,
    DELIVERY_LOCATION_COORDS_LABEL,
    DELIVERY_LOCATION_COORDS_NAME,
    MATERIAL_NAME_LABEL,
    MATERIAL_NAME_NAME,
    MATERIAL_NAME_PLACEHOLDER,
    REQUIRED_QUANTITY_NAME,
    REQUIRED_QUANTITY_LABEL,
    REQUIRED_MATERIAL_QUANTITY_NAME,
    REQUIRED_MATERIAL_QUANTITY_LABEL,
    REQUIRED_QUANTITY_PLACEHOLDER,
    TRUCK_COST_LABEL,
    TRUCK_COST_NAME,
    TRUCK_COST_PLACEHOLDER,
    TRUCK_PRICE_LABEL,
    TRUCK_PRICE_NAME,
    TRUCK_PRICE_PLACEHOLDER,
    MINIMUM_HOURS_NAME,
    MINIMUM_HOURS_LABEL,
    MINIMUM_HOURS_PLACEHOLDER,
    DELIVERY_LOCATION_NAME,
    DELIVERT_LOCATION_LABEL,
    MATERIAL_DETAILS_HEADER,
    USE_MARKUP_LABEL,
    USE_MARKUP_NAME,
    USE_MARKUP_PLACEHOLDER,
    MATERIAL_COST_LABEL,
    MATERIAL_COST_NAME,
    MATERIAL_COST_PLACEHOLDER,
    MATERIAL_PRICE_LABEL,
    MATERIAL_PRICE_NAME,
    MATERIAL_PRICE_PLACEHOLDER,
    BID_TOOL_WARNING,
    BID_TRUCK_COST_NAME,
    BID_TRUCK_PRICE_NAME,
    JOB_MAP_WARNING,
    JOB_MAP_FAILURE,
    TRUCKING_VENDOR,
    TRUCKING_VENDOR_LABEL,
    TRUCKING_VENDOR_PLACEHOLDER,
  } = AddTruckFormProps;
  const queryClient = useQueryClient();
  const createJobData = queryClient.getQueryData(["createJobDataKey"]);
  const { materialsList, materialTruckList, addTruckMaterial } = useMaterials();
  const { truckDetails, appendTruckDetail } = useTruckDetailContext();
  const { Option } = Select;
  const [timeDurationValue, setTimeDurationValue] = useState({
    value: undefined,
    text: "",
  });
  const [distanceMilesValue, setDistanceMilesValue] = useState({
    value: undefined,
    text: "",
  });
  const [distanceTimeValue, setDistanceTimeValue] = useState("");

  const [truckingCostValue, setTruckingCostValue] = useState<
    number | undefined
  >(undefined);
  const [truckingPriceValue, setTruckingPriceValue] = useState<
    number | undefined
  >(undefined);
  const [useMarkupValue, setUseMarkupValue] = useState<number | undefined>(
    undefined,
  );
  const [materialPriceValue, setMaterialPriceValue] = useState<
    number | undefined
  >(undefined);
  const [materialCostValue, setMaterialCostValue] = useState<
    number | undefined
  >(formatNumber(Number(vendorMaterialCost)));
  const [quantityValue, setQuantityValue] = useState<number | undefined>(
    undefined,
  );
  const [materialQuantityValue, setMaterialQuantityValue] = useState<
    number | undefined
  >(undefined);
  const [minimumHoursValue, setMinimumHoursValue] = useState<
    number | undefined
  >(undefined);
  const [selectedUnit, setSelectedUnit] = useState(TON_TXT);
  const [selectedMaterialUnit, setSelectedMaterialUnit] = useState(TON_TXT);
  const [selectedQuantityUnit, setSelectedQuantityUnit] = useState(TON_TXT);
  const [isOpen, setIsOpen] = useState(false);
  const [checkboxStates, setCheckboxStates] = useState<{
    [key: string]: boolean;
  }>({});
  const [selectedTruckCodes, setSelectedTruckCodes] = useState<string[]>([]);
  const [selectedTruckValues, setSelectedTruckValues] = useState<string[]>([]);
  const [vendorSelectedTag, setVendorSelectedTag] = useState([]);
  const [selectedVendorName, setSelectedVendorName] = useState<string>("");
  const [selectedMaterialName, setSelectedMaterialName] = useState<string>("");

  const handleOpenDrawer = () => setIsOpen(true);
  const handleCloseDrawer = () => setIsOpen(false);
  const handleUnitChange = (value: string) => {
    setSelectedUnit(value);
  };
  const handleMaterialUnitChange = (value: string) => {
    setSelectedMaterialUnit(value);
  };
  const handleQuantityUnitChange = (value: string) => {
    if (value !== HOUR_TXT) {
      setValue(MINIMUM_HOURS_NAME, undefined);
      setMinimumHoursValue(undefined);
    }
    setSelectedQuantityUnit(value);
  };
  const selectAfterFieldProps = (
    <Select
      value={selectedUnit}
      onChange={handleUnitChange}
      className={styles.selectSection}
    >
      <Option value={TON_TXT}>
        {<span className={styles.unitContainer}>{TON_TXT}</span>}
      </Option>
      <Option value={LOAD_TXT}>
        {<span className={styles.unitContainer}>{LOAD_TXT}</span>}
      </Option>
      <Option value={HOUR_TXT}>
        {<span className={styles.unitContainer}>{HOUR_TXT}</span>}
      </Option>
    </Select>
  );
  const selectMaterialAfterFieldProps = (
    <Select
      value={selectedMaterialUnit}
      onChange={handleMaterialUnitChange}
      className={styles.selectSection}
    >
      <Option value={TON_TXT}>
        {<span className={styles.unitContainer}>{TON_TXT}</span>}
      </Option>
      <Option value={LOAD_TXT}>
        {<span className={styles.unitContainer}>{LOAD_TXT}</span>}
      </Option>
    </Select>
  );
  const selectQuantityAfterFieldProps = (
    <Select
      value={selectedQuantityUnit}
      onChange={handleQuantityUnitChange}
      className={styles.selectSection}
    >
      <Option value={TON_TXT}>
        {<span className={styles.unitContainer}>{TON_TXT}</span>}
      </Option>
      <Option value={LOAD_TXT}>
        {<span className={styles.unitContainer}>{LOAD_TXT}</span>}
      </Option>
      <Option value={HOUR_TXT}>
        {<span className={styles.unitContainer}>{HOUR_TXT}</span>}
      </Option>
    </Select>
  );

  const {
    MilesData,
    GetBidToolsData,
    GetMaterialVendorList,
    GetMaterialOptionList,
    GetLocationFromCoordinates,
  } = CreateJobServices();
  const {
    data: materialOptions,
    refetch: refetchMaterialOptions,
    isFetching: isFetchingMaterialOptions,
  } = GetMaterialOptionList(!!selectedVendorName ? vendorSelectedTag?.[0] : "");
  const { data: materialVendors, isFetching: isFetchingMaterialVendors } =
    GetMaterialVendorList();
  const vendorOptions = useMemo(() => {
    return materialVendors?.map((quarry) => {
      return {
        id: quarry?.id,
        label: quarry?.quarryName,
        value: quarry?.id,
        address: quarry?.address,
        lat: quarry?.lat,
        lng: quarry?.lng,
      };
    });
  }, [materialVendors]);

  const [locLat, setLocLat] = useState("");
  const [locLng, setLocLng] = useState("");
  const { data: locationData, refetch: refetchLocationData } =
    GetLocationFromCoordinates({
      lat: locLat,
      lon: locLng,
    });

  const { mutate: milesFetchData } = MilesData();
  const { data: bidToolsData } = GetBidToolsData();

  const truckDataOptions = getTruckOptions(dropdownData);
  const initialCheckboxResetStates = truckDataOptions?.reduce(
    (acc, item) => {
      acc[item.label] = false;
      return acc;
    },
    {} as { [key: string]: boolean },
  );
  useEffect(() => {
    setCheckboxStates(initialCheckboxResetStates);
  }, [setCheckboxStates]);
  const {
    watch,
    setValue,
    getValues,
    handleSubmit,
    trigger,
    clearErrors,
    setError,
    resetField,
  } = useFormContext();
  const resetAddFormFields = () => {
    setSelectedTruckCodes([]);
    setSelectedVendorName("");
    setValue(MINIMUM_HOURS_NAME, undefined);
    setMinimumHoursValue(undefined);
    setCheckboxStates(initialCheckboxResetStates);
    setQuantityValue(undefined);
    setTruckingPriceValue(undefined);
    setTruckingCostValue(undefined);
    setValue(TAB_FIELD_NAME, undefined);
    setValue(PICKUP_LOCATION_NAME, "");
    setValue(DELIVERY_LOCATION_NAME, "");
    setValue(PICKUP_LOCATION_COORDS_NAME, "");
    setValue(DELIVERY_LOCATION_COORDS_NAME, "");
    setValue(MATERIAL_NAME_NAME, null);
    setSelectedTag([]);
    setValue(REQUIRED_QUANTITY_NAME, undefined);
    setValue(TRUCK_PRICE_NAME, undefined);
    setValue(TRUCK_COST_NAME, undefined);
    setValue(DELIVERY_LOCATION_NAME, presetDropLocation);
    setValue(
      DELIVERY_LOCATION_COORDS_NAME,
      String(
        String(presetDropCoordinates?.["lat"]) +
          ", " +
          String(presetDropCoordinates?.["lng"]),
      ),
    );
    setValue(TRUCKING_VENDOR, null);
    setVendorSelectedTag([]);
    BidToolFromKeys.map((item) => setValue(item, undefined));
    BidToolFromKeys.map((item) => clearErrors(item));
    setValue(BID_TRUCK_PRICE_NAME, "");
    setValue(BID_TRUCK_COST_NAME, "");
    truckDetaildFormKeys.map((item) => clearErrors(item));
    setSelectedMaterialUnit(TON_TXT);
    setSelectedQuantityUnit(TON_TXT);
    setSelectedUnit(TON_TXT);
  };
  const resetVendorFormFields = () => {
    setSelectedTruckCodes([]);
    setCheckboxStates(initialCheckboxResetStates);
    setQuantityValue(undefined);
    setTruckingPriceValue(undefined);
    setTruckingCostValue(undefined);
    setMaterialPriceValue(undefined);
    setMaterialCostValue(vendorMaterialCost);
    setUseMarkupValue(undefined);
    setValue(TAB_FIELD_NAME, undefined);
    truckVendorDetailKeys.map((item) => setValue(item, undefined));
    truckVendorDetailKeys.map((item) => clearErrors(item));
    BidToolFromKeys.map((item) => setValue(item, undefined));
    setValue(BID_TRUCK_PRICE_NAME, "");
    setValue(BID_TRUCK_COST_NAME, "");
    BidToolFromKeys.map((item) => clearErrors(item));
    setValue(TRUCKING_VENDOR, undefined);
    setValue(REQUIRED_MATERIAL_QUANTITY_NAME, undefined);
    setSelectedMaterialUnit(TON_TXT);
    setSelectedQuantityUnit(TON_TXT);
    setSelectedUnit(TON_TXT);
    setValue(MINIMUM_HOURS_NAME, undefined);
    setMinimumHoursValue(undefined);
  };
  const resetBidToolFormFields = () => {
    BidToolFromKeys.forEach((item) => resetField(item));
    const baseTruckAssumptions =
      bidToolsData.data?.[0]?.baseTruckAssumption || [];

    const defaultTruckType = baseTruckAssumptions?.[0]?.truckType;

    const truckTypeRateFields = baseTruckAssumptions.map(
      (item) => `${item.truckType}_biddingTons`,
    );
    const truckTypeBiddingFields = baseTruckAssumptions.map(
      (item) => `${item.truckType}_biddingTons`,
    );

    const fieldsToSet = [
      ...truckTypeRateFields,
      ...truckTypeBiddingFields,
      "truckType",
      "texasDieselAvg",
      "truckRate",
      "oneWayTime",
      "oneWayMiles",
      "loadingTime",
      "unloadingTime",
      "deadheadForwardTime",
      "deadheadForwardMiles",
      "deadheadBackwardTime",
      "deadheadBackwardMiles",
      "timeBuffer",
      "loadsPerDayTruck",
      "initialPercentage",
      "truckPrice",
      "truckingPriceUnit",
      "truckingCost",
      "truckingCostUnit",
      "actualBid",
      "averageNumberLoads",
      "maxNumberLoads",
    ];
    if (Object?.keys(savedBidToolValue)?.length !== 0) {
      fieldsToSet?.map((field) => setValue(field, savedBidToolValue?.[field]));
    } else {
      fieldsToSet?.map((field) => {
        if (
          field === AddTruckFormProps.BID_TRUCK_PRICE_NAME ||
          field === AddTruckFormProps.BID_TRUCK_COST_NAME
        )
          setValue(field, "");
        else if (field === AddTruckFormProps.BID_TRUCK_TRUCK_TYPE_NAME)
          setValue(field, defaultTruckType);
        else resetField(field);
      });
    }
  };
  const handleAddFormResetClose = () => {
    onClose();
    resetAddFormFields();
  };
  const handleVendorFormResetClose = () => {
    onClose();
    resetVendorFormFields();
  };
  const materialDataOptions = useMemo(
    () => getMaterialOptions(materialOptions),
    [materialOptions],
  );
  const handleFormSubmit = () => {
    const pickUpCoord = String(getValues(PICKUP_LOCATION_COORDS_NAME)).split(
      ", ",
    );
    const dropOffCoord = String(getValues(DELIVERY_LOCATION_COORDS_NAME)).split(
      ", ",
    );
    const formValues = getValues();
    const payload = [
      {
        truckingQuantity: Number(stripCurrencyFormatting(formValues.quantity)),
        truckingQuantityUnitType: selectedQuantityUnit,
        minimumHours: formValues.minimumHours
          ? Number(stripCurrencyFormatting(formValues.minimumHours))
          : undefined,
        truckType: selectedTruckCodes,
        vendor: !!selectedVendorName
          ? selectedVendorName
          : vendorSelectedTag?.[0],
        vendorId: !!selectedVendorName ? vendorSelectedTag?.[0] : "",
        pickupLocation: formValues.pickupLocation,
        deliveryLocation: formValues.deliveryLocation,
        materialTruckName: formValues.materialTruckName,
        materialSelected: selectedMaterialName,
        truckingPrice: Number(
          stripCurrencyFormatting(formValues.truckingPrice),
        ),
        truckingCost: Number(stripCurrencyFormatting(formValues.truckCost)),
        milesDuration: distanceTimeValue,
        truckingPriceType: selectedQuantityUnit,
        truckingCostType: selectedQuantityUnit,
        landedPrice: Number(stripCurrencyFormatting(formValues.truckingPrice)),
        landedPriceType: selectedQuantityUnit,
        milesData: distanceMilesValue,
        duration: timeDurationValue,
        type: TruckMaterialType.TRUCK_TYPE,
        truckTypeValues: selectedTruckValues,
        uniqKey: uuidv4(),
        assigned: false,
        pickUpLatLng: {
          lat: pickUpCoord[0],
          lng: pickUpCoord[1],
        },
        dropOffLatLng: {
          lat: dropOffCoord[0],
          lng: dropOffCoord[1],
        },
        pickupIsJobSite: pickUpCheckboxState,
        destinationIsJobSite: deliveryCheckboxState,
      },
    ];
    if (selectedTruckCodes?.length > 0) {
      appendTruckDetail(payload);
      resetAddFormFields();
      onClose();
    } else {
      message.error(TRUCK_TYPE_ERROR_MSG);
    }
  };
  const handleAddValidationErrors = (errors) => {
    if (errors) {
      BidToolFromKeys.map((item) => clearErrors(item));
      const keys = errors ? Object.keys(errors) : [];
    }
  };
  const handleAddVendorValidationErrors = (errors) => {
    if (errors) {
      BidToolFromKeys.map((item) => clearErrors(item));
      const keys = errors ? Object.keys(errors) : [];
    }
  };
  const validateBidToolField = (name: string, value: any) => {
    // Clear any existing error for this field first
    clearErrors(name);

    if (value === undefined || value === null || value === "") {
      setError(name, {
        type: "required",
        message: "required",
      });
      return false;
    }

    // Convert to string for validation and trim whitespace
    const stringValue = String(value).trim();

    // Handle currency fields by removing $ sign and commas
    let cleanedValue = stripCurrencyFormatting(stringValue);

    if (name === "truckPrice" || name === "truckingCost") {
      cleanedValue = stringValue.replace(/[$,]/g, "");
    }

    // Convert to number for further validation
    const numValue = Number(cleanedValue);

    // Field-specific validations
    switch (name) {
      case "truckPrice":
      case "truckingCost":
        if (numValue <= 0) {
          setError(name, {
            type: "min",
            message: "Invalid entry",
          });
          return false;
        }
        // Format to 2 decimal places and update value
        setValue(name, numValue?.toFixed(2), { shouldValidate: true });
        break;
        // Format to 2 decimal places and update value
        if (!!noEnteredValue)
          setValue(name, numValue?.toFixed(2), { shouldValidate: true });
        break;
    }
    const baseTruckAssumptions =
      bidToolsData.data?.[0]?.baseTruckAssumption || [];

    // Step 1: Create a Set of valid truck types
    const validTruckTypes = new Set(
      baseTruckAssumptions.map((item) => item.truckType),
    );
    if (name.endsWith("_biddingTons")) {
      const truckType = name.replace("_biddingTons", "");

      if (validTruckTypes.has(truckType)) {
        if (!Number.isInteger(numValue)) {
          setError(name, {
            type: "typeError",
            message: "Invalid entry",
          });
          return false;
        }

        if (numValue <= 0) {
          setError(name, {
            type: "min",
            message: "Invalid entry",
          });
          return false;
        }
      }
    }
    // If we got here, validation passed - ensure error is cleared
    clearErrors(name);
    return true;
  };

  const [savedBidToolValue, setSavedBidToolValues] = useState({});
  const handleBiddingToolSubmit = async () => {
    // Clear all errors first
    clearErrors();
    const baseTruckAssumptions =
      bidToolsData.data?.[0]?.baseTruckAssumption || [];

    const truckTypeRateFields = baseTruckAssumptions.map(
      (item) => `${item.truckType}_biddingTons`,
    );
    const truckTypeBiddingFields = baseTruckAssumptions.map(
      (item) => `${item.truckType}_biddingTons`,
    );
    const fieldsToValidate = ["truckPrice", "truckingCost"];

    let allValid = true;
    const values = getValues();

    // Validate all fields
    fieldsToValidate.forEach((field) => {
      if (!validateBidToolField(field, values[field])) {
        allValid = false;
      }
    });

    if (!allValid) {
      message.error(BID_TOOL_WARNING);
      return;
    }

    // Process valid submission
    const truckingPrice = Number(watch("truckPrice"));
    if (!isNaN(truckingPrice)) {
      setValue(TRUCK_PRICE_NAME, formatNumber(truckingPrice?.toFixed(2)));
      setValue(
        TRUCK_COST_NAME,
        formatNumber(Number(truckingPrice * 0.875)?.toFixed(2)),
      );
      clearErrors("truckingCost");
    }
    setSavedBidToolValues(values);
    handleCloseDrawer();
    message.success("Bid Submitted Successfully");
  };
  const handleVendorFormSubmit = () => {
    const formValues = getValues();
    const getNumberToTwoPlaces = (number) => {
      const n = Number(number);
      return isFinite(n) ? Number(n?.toFixed(2)) : null;
    };
    const netExpense =
      getNumberToTwoPlaces(
        getNumberToTwoPlaces(
          Number(stripCurrencyFormatting(formValues.truckCost)),
        ) +
          getNumberToTwoPlaces(
            Number(stripCurrencyFormatting(materialCostValue)),
          ),
      ) * Number(stripCurrencyFormatting(formValues.quantity));
    const netRevenue = !isNaN(
      Number(
        getNumberToTwoPlaces(
          Number(stripCurrencyFormatting(formValues.truckingPrice)),
        ) +
          getNumberToTwoPlaces(
            Number(stripCurrencyFormatting(formValues.materialPrice)),
          ),
      )?.toFixed(2),
    )
      ? Number(
          getNumberToTwoPlaces(
            Number(stripCurrencyFormatting(formValues.truckingPrice)) +
              getNumberToTwoPlaces(
                Number(stripCurrencyFormatting(formValues.materialPrice)),
              ),
          ),
        )?.toFixed(2)
      : 0;
    const totalSaleAmt =
      netRevenue * Number(stripCurrencyFormatting(formValues.quantity));
    //Add Material details payload
    const payload = {
      uniqKey: uuidv4(),
      type: TruckMaterialType.MATERIAL_TYPE,
      truckType: selectedTruckCodes,
      materialId:
        materialsList.updatedTopQuarriesInfo?.material?.[0]?.materialId,
      label: materialsList.updatedTopQuarriesInfo?.material?.[0]?.label,
      value: materialsList.updatedTopQuarriesInfo?.material?.[0]?.value,
      category: materialsList.updatedTopQuarriesInfo?.material?.[0]?.category,
      categoryKey:
        materialsList.updatedTopQuarriesInfo?.material?.[0]?.categoryKey,
      subShortName:
        materialsList.updatedTopQuarriesInfo?.material?.[0]?.subShortName,
      materialTax:
        materialsList.updatedTopQuarriesInfo?.material?.[0]?.materialTax,
      additionalTaxRate:
        materialsList.updatedTopQuarriesInfo?.material?.[0]?.additionalTaxRate,
      truckingPrice: Number(stripCurrencyFormatting(formValues.truckingPrice)),
      truckingPriceType: selectedQuantityUnit,
      truckingCost: Number(stripCurrencyFormatting(formValues.truckCost)),
      truckingCostType: selectedQuantityUnit,
      truckingQuantity: Number(stripCurrencyFormatting(formValues.quantity)),
      truckingQuantityUnitType: selectedQuantityUnit,
      materialQuantity: Number(
        stripCurrencyFormatting(formValues.materialQuantity),
      ),
      materialQuantityUnitType: selectedMaterialUnit,
      minimumHours: getValues(MINIMUM_HOURS_NAME)
        ? Number(stripCurrencyFormatting(getValues(MINIMUM_HOURS_NAME)))
        : undefined,
      vendor: materialsList.vendor,
      vendorId: materialsList.vendorId,
      quarryNickName: materialsList.updatedTopQuarriesInfo?.quarryNickName,
      vendorTerms: materialsList.updatedTopQuarriesInfo?.accountTerms,
      vendorDiscountTerms:
        materialsList.updatedTopQuarriesInfo?.payDiscountTerms,
      vendorDiscount: materialsList.updatedTopQuarriesInfo?.payDiscount,
      pickUpAddress: materialsList.updatedTopQuarriesInfo?.address,
      pickUpLatLng: {
        lat: materialsList.updatedTopQuarriesInfo?.lat,
        lng: materialsList.updatedTopQuarriesInfo?.lng,
      },
      materialCostAtQuarryPerTon: Number(
        stripCurrencyFormatting(materialCostValue),
      ),
      materialCost: Number(stripCurrencyFormatting(materialCostValue)),
      materialCostType: venodorMaterialUnit,
      duration: materialsList.updatedTopQuarriesInfo?.duration,
      milesData: materialsList.updatedTopQuarriesInfo?.distance,
      landedPrice:
        selectedMaterialUnit === selectedQuantityUnit
          ? Number(stripCurrencyFormatting(formValues.materialPrice)) +
            Number(stripCurrencyFormatting(formValues.truckingPrice))
          : "-",
      landedPriceType:
        selectedMaterialUnit === selectedQuantityUnit
          ? selectedMaterialUnit
          : "-",
      landedCost:
        Number(stripCurrencyFormatting(formValues.materialCost)) +
        Number(stripCurrencyFormatting(formValues.truckCost)),
      landedCostType: selectedUnit,
      totalSale: Number(totalSaleAmt?.toFixed(2)),
      totalExepense: Number(netExpense?.toFixed(2)),
      totalProfit: Number((totalSaleAmt - netExpense)?.toFixed(2)),
      totalProfitPercentage: !totalSaleAmt
        ? 0
        : Number(
            (((totalSaleAmt - netExpense) / totalSaleAmt) * 100).toFixed(2),
          ),
      diameter: false,
      materialName: materialsList.materialName,
      materialSelected: materialsList.materialSelected,
      useMaterialMarkup: Number(
        stripCurrencyFormatting(formValues.useMaterialMarkup),
      ),
      materialPrice: Number(stripCurrencyFormatting(formValues.materialPrice)),
      materialPriceType: selectedMaterialUnit,
      category: materialsList?.category,
      subCategory: materialsList?.subCategory,
      material: materialsList?.material,
      subShortName: materialsList?.subShortName,
      materialTax: materialsList?.materialTax,
    };
    if (selectedTruckCodes?.length > 0) {
      addTruckMaterial(payload);
      resetVendorFormFields();
      onClose();
      materialDrawerClose();
    } else {
      message.error(TRUCK_TYPE_ERROR_MSG);
    }
  };

  const onKeyDownHander = (e: React.KeyboardEventHandler<HTMLInputElement>) => {
    // Allow control and navigation keys
    if (
      allowedKeys?.includes(e?.key) ||
      e?.ctrlKey ||
      e?.altKey ||
      e?.metaKey
    ) {
      return;
    }

    // Allow digitls
    if (/^\d$/.test(e?.key)) {
      return;
    }

    // Allow decimal point if enabled
    if (e?.key === ".") {
      const currentValue = e?.target?.value?.toString() || "";
      if (currentValue.includes(".")) {
        e?.preventDefault();
        return;
      }
      return;
    }

    e?.preventDefault();
  };

  const onBlurHandler = (
    name: string,
    e: React.FocusEvent<HTMLInputElement, Element>,
  ) => {
    let value, formattedValue;
    if (e.target.value) {
      value = Number(stripCurrencyFormatting(e.target.value));
      formattedValue = formatNumber(value?.toFixed(2));
      if (!isNaN(Number(value))) {
        if (name === TRUCK_PRICE_NAME) {
          const costValue = formatNumber((Number(value) * 0.875)?.toFixed(2));
          setValue(TRUCK_COST_NAME, costValue);
          setTruckingCostValue(costValue);
          setTruckingPriceValue(value);
          setValue(name, value);
          trigger(TRUCK_PRICE_NAME);
          trigger(TRUCK_COST_NAME);
        }
        if (name === REQUIRED_QUANTITY_NAME) {
          setQuantityValue(formattedValue);
          setValue(name, formattedValue);
          trigger(REQUIRED_QUANTITY_NAME);
        }
        if (name === REQUIRED_MATERIAL_QUANTITY_NAME) {
          setMaterialQuantityValue(formattedValue);
          setValue(name, formattedValue);
          trigger(REQUIRED_MATERIAL_QUANTITY_NAME);
        }
        if (name === TRUCK_COST_NAME) {
          setTruckingCostValue(formattedValue);
          setValue(name, formattedValue);
        }
        if (name === MATERIAL_COST_NAME) {
          setMaterialCostValue(formattedValue);
          setValue(name, formattedValue);
          trigger(MATERIAL_COST_NAME);
          const markUpPercent = formatNumber(
            getMarginPercentFromMaterialPrice(
              Number(stripCurrencyFormatting(materialPriceValue)),
              value,
            ),
          );
          setValue(USE_MARKUP_NAME, markUpPercent);
        }
        if (name === MATERIAL_PRICE_NAME) {
          setMaterialPriceValue(formattedValue);
          setValue(name, formattedValue);
          trigger(MATERIAL_PRICE_NAME);
          const markUpPercent = formatNumber(
            getMarginPercentFromMaterialPrice(
              value,
              Number(stripCurrencyFormatting(materialCostValue)),
            ),
          );
          setValue(USE_MARKUP_NAME, markUpPercent);
        }
        if (name === USE_MARKUP_NAME) {
          setUseMarkupValue(formattedValue);
          setValue(name, formattedValue);
          if (value >= 100) {
            trigger(USE_MARKUP_NAME);
            return;
          }
          if (
            (!materialCostValue || Number(materialCostValue) === 0) &&
            !!materialPriceValue
          )
            return;
          const markupPrice = formatNumber(
            getMaterialPriceFromMargin(
              Number(stripCurrencyFormatting(materialCostValue)),
              value,
            ),
          );
          setValue(MATERIAL_PRICE_NAME, markupPrice);
          trigger(MATERIAL_PRICE_NAME);
          trigger(USE_MARKUP_NAME);
        }
        if (name === MINIMUM_HOURS_NAME) {
          setMinimumHoursValue(formattedValue);
        }
        setValue(name, formattedValue);
      } else {
        setValue(name, null);
      }
    } else {
      if (name === MATERIAL_COST_NAME) {
        trigger(MATERIAL_COST_NAME);
      } else if (name === USE_MARKUP_NAME) {
        trigger(USE_MARKUP_NAME);
      }
    }
  };
  const handleCheckChange = (
    name: string,
    value: boolean,
    truckCode: string,
  ) => {
    setCheckboxStates((prev) => ({ ...prev, [name]: value }));
    setValue(name, value);

    setSelectedTruckCodes((prevCodes) => {
      if (value) {
        return [...prevCodes, truckCode];
      } else {
        return prevCodes.filter((code) => code !== truckCode);
      }
    });

    const values = Object.values({ ...checkboxStates, [name]: value });
    const bothTypes =
      values.slice(0, 6).every((val) => val) &&
      values.slice(6).every((val) => !val);
    const small =
      values.slice(3, 6).every((val) => val) &&
      values.slice(0, 3).every((val) => !val) &&
      values.slice(6).every((val) => !val);
    const big =
      values.slice(0, 4).every((val) => val) &&
      values.slice(4).every((val) => !val);

    if (bothTypes) {
      setValue(TAB_FIELD_NAME, buttonOptionsKeys.BOTH);
    } else if (big) {
      setValue(TAB_FIELD_NAME, buttonOptionsKeys.BIG);
    } else if (small) {
      setValue(TAB_FIELD_NAME, buttonOptionsKeys.SMALL);
    }
  };
  const handleSpecialCases = (tab?: string) => {
    setCheckboxStates((prevCheckboxStates) => {
      const newCheckboxStates = { ...prevCheckboxStates };
      let updatedTruckCodes: string[] = [];

      if (tab === buttonOptionsKeys.BOTH) {
        Object.keys(newCheckboxStates).forEach((key, index) => {
          newCheckboxStates[key] = index < 6;
        });
        updatedTruckCodes = truckDataOptions
          .filter((_, index) => index < 6)
          .map((truck) => truck.truckCode);
      } else if (tab === buttonOptionsKeys.BIG) {
        Object.keys(newCheckboxStates).forEach((key, index) => {
          newCheckboxStates[key] = index < 4;
        });
        updatedTruckCodes = truckDataOptions
          .filter((_, index) => index < 4)
          .map((truck) => truck.truckCode);
      } else if (tab === buttonOptionsKeys.SMALL) {
        Object.keys(newCheckboxStates).forEach((key, index) => {
          newCheckboxStates[key] = index >= 3 && index < 6;
        });
        updatedTruckCodes = truckDataOptions
          .filter((_, index) => index >= 3 && index < 6)
          .map((truck) => truck.truckCode);
      } else {
        Object.keys(newCheckboxStates).forEach((key) => {
          newCheckboxStates[key] = false;
        });
        updatedTruckCodes = [];
      }
      // Update react-hook-form values
      Object.keys(newCheckboxStates).forEach((key) => {
        setValue(key, newCheckboxStates[key]);
      });
      // Updating truck codes here
      setSelectedTruckCodes(updatedTruckCodes);
      return newCheckboxStates;
    });
  };

  const selectedTab = watch(TAB_FIELD_NAME);
  const pickUpLocation = watch(PICKUP_LOCATION_NAME);
  const deliveryLocation = watch(DELIVERY_LOCATION_NAME);
  const pickupCoords = watch(PICKUP_LOCATION_COORDS_NAME);
  const delieveryCoords = watch(DELIVERY_LOCATION_COORDS_NAME);

  useEffect(() => {
    if (selectedTab) {
      handleSpecialCases(selectedTab);
    } else {
      handleSpecialCases("");
    }
  }, [selectedTab]);
  const [pickUpCheckboxState, setPickUpCheckboxState] = useState(false);
  const [deliveryCheckboxState, setDeliveryCheckboxState] = useState(true);
  useEffect(() => {
    const coord = String(getValues(PICKUP_LOCATION_COORDS_NAME)).split(", ");
    const deliveryCoord = String(
      getValues(DELIVERY_LOCATION_COORDS_NAME),
    ).split(", ");
    const dlat = String(deliveryCoord[0]);
    const dlng = String(deliveryCoord[1]);
    const lat = String(coord[0]);
    const lng = String(coord[1]);
    if (
      !!pickUpLocation &&
      !!deliveryLocation &&
      !!coord &&
      !!deliveryCoord &&
      !!dlat &&
      !!dlng &&
      !!lat &&
      !!lng
    ) {
      let url =
        "https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&destinations=" +
        [dlat, dlng] +
        "&origins=" +
        [lat, lng] +
        "&key=AIzaSyB781k9fNf61hnxE3A6cvcascwhAhIVIK4";
      let payload = {
        entityData: {
          url,
        },
      };
      milesFetchData(payload, {
        onSuccess: (data) => {
          const distanceDuration =
            String(data?.duration.text) + ", " + String(data?.distance?.text);
          setTimeDurationValue(data?.duration);
          setDistanceMilesValue(data?.distance);
          setDistanceTimeValue(distanceDuration);
        },
      });
    }
    const presetCoordsString = `${presetDropCoordinates?.lat}, ${presetDropCoordinates?.lng}`;

    const validateLocation = (location, coordsName, setState) => {
      if (
        presetDropLocation !== location ||
        presetCoordsString !== coordsName
      ) {
        setState(false);
      } else {
        setState(true);
      }
    };

    validateLocation(pickUpLocation, pickupCoords, setPickUpCheckboxState);
    validateLocation(
      deliveryLocation,
      delieveryCoords,
      setDeliveryCheckboxState,
    );
  }, [pickUpLocation, deliveryLocation, pickupCoords, delieveryCoords]);

  const openGoogleMaps = ({
    pickUpLat,
    pickUpLng,
    deliveryLat,
    deliveryLng,
  }: {
    pickUpLat?: string;
    pickUpLng?: string;
    deliveryLat?: string;
    deliveryLng?: string;
  }) => {
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${pickUpLat},${pickUpLng}&destination=${deliveryLat},${deliveryLng}`;
    window.open(googleMapsUrl, "_blank");
  };
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const handleOpenWarningModal = () => setIsWarningModalOpen(true);
  const handleCloseWarningModal = () => setIsWarningModalOpen(false);
  const projectSummaryContents = sampleProjectSummaryBody({
    perUnitRevenue: Number(
      stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME)),
    )?.toFixed(2),
    projectRevenue: (
      Number(stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME))) *
      Number(stripCurrencyFormatting(getValues(REQUIRED_QUANTITY_NAME)))
    )?.toFixed(2),
    projectPercent: (
      Number(
        stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME)) /
          Number(stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME))),
      ) * 100
    )?.toFixed(2),
    cogsPerUnit: Number(
      stripCurrencyFormatting(getValues(TRUCK_COST_NAME)),
    )?.toFixed(2),
    projectCogs: (
      Number(stripCurrencyFormatting(getValues(TRUCK_COST_NAME))) *
      Number(stripCurrencyFormatting(getValues(REQUIRED_QUANTITY_NAME)))
    )?.toFixed(2),
    cogsPercent: (
      ((Number(stripCurrencyFormatting(getValues(TRUCK_COST_NAME))) *
        Number(stripCurrencyFormatting(getValues(REQUIRED_QUANTITY_NAME)))) /
        (Number(stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME))) *
          Number(stripCurrencyFormatting(getValues(REQUIRED_QUANTITY_NAME))))) *
      100
    ).toFixed(2),
    profitPerUnit: (
      Number(stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME))) -
      Number(stripCurrencyFormatting(getValues(TRUCK_COST_NAME)))
    )?.toFixed(2),
    projectProfit: (
      (Number(stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME))) -
        Number(stripCurrencyFormatting(getValues(TRUCK_COST_NAME)))) *
      Number(stripCurrencyFormatting(getValues(REQUIRED_QUANTITY_NAME)))
    )?.toFixed(2),
    profitPercent: (
      ((Number(stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME))) -
        Number(stripCurrencyFormatting(getValues(TRUCK_COST_NAME)))) /
        Number(stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME)))) *
      100
    )?.toFixed(2),
  });
  const quantityField = getValues(REQUIRED_QUANTITY_NAME);
  const materialQuantityField = getValues(REQUIRED_MATERIAL_QUANTITY_NAME);
  const truckingCostField = getValues(TRUCK_COST_NAME);
  const truckingPriceField = getValues(TRUCK_PRICE_NAME);
  const materialPriceField = getValues(MATERIAL_PRICE_NAME);
  const useMarkupField = getValues(USE_MARKUP_NAME);
  const projectSummaryContentsMaterial = sampletProjectSummaryBodyMaterial({
    averageRevenue:
      Number(stripCurrencyFormatting(getValues(TRUCK_COST_NAME))) +
      Number(stripCurrencyFormatting(materialCostValue)),
    materialPrice: Number(
      stripCurrencyFormatting(getValues(MATERIAL_PRICE_NAME)),
    ),
    truckingPrice: Number(stripCurrencyFormatting(getValues(TRUCK_PRICE_NAME))),
    truckingCost: Number(stripCurrencyFormatting(getValues(TRUCK_COST_NAME))),
    estimatedQuantity: Number(
      stripCurrencyFormatting(getValues(REQUIRED_QUANTITY_NAME)),
    ),
    materailEstimatedQuantity: Number(
      stripCurrencyFormatting(getValues(REQUIRED_MATERIAL_QUANTITY_NAME)),
    ),
    materialCost: Number(stripCurrencyFormatting(materialCostValue)),
  });
  useEffect(() => {
    setValue(
      MATERIAL_COST_NAME,
      formatNumber(Number(vendorMaterialCost)?.toFixed(2)),
    );
    setMaterialCostValue(formatNumber(Number(vendorMaterialCost)));
  }, [vendorMaterialCost]);
  useEffect(() => {
    setQuantityValue(quantityField);
  }, [quantityField]);
  useEffect(() => {
    setMaterialQuantityValue(materialQuantityField);
  }, [materialQuantityField]);
  useEffect(() => {
    setTruckingCostValue(truckingCostField);
  }, [truckingCostField]);
  useEffect(() => {
    setTruckingPriceValue(truckingPriceField);
  }, [truckingPriceField]);
  useEffect(() => {
    setUseMarkupValue(useMarkupField);
  }, [useMarkupField]);
  useEffect(() => {
    setMaterialPriceValue(materialPriceField);
  }, [materialPriceField]);
  useEffect(() => {
    const currentCodes = truckDataOptions
      ?.filter((option) => selectedTruckCodes?.includes(option.truckCode))
      ?.map((option) => option.value);
    setSelectedTruckValues(currentCodes);
  }, [selectedTruckCodes]);
  const [isNegativeMarkupModalOpen, setNegativeMarkupModalOpen] =
    useState(false);
  const handleNegativeMarkupModalOpen = () => {
    setNegativeMarkupModalOpen(true);
  };
  const handleNegativeMarkupModalClose = () => {
    setNegativeMarkupModalOpen(false);
  };
  const handleMaterialVendorSubmit = () => {
    const markUpVal = getValues(USE_MARKUP_NAME);
    if (Number(markUpVal) < 0) {
      handleNegativeMarkupModalOpen();
    } else {
      handleVendorFormSubmit();
    }
  };
  const handleNegativeMarkupModalSubmit = () => {
    handleVendorFormSubmit();
    handleNegativeMarkupModalClose();
  };
  const [selectedTag, setSelectedTag] = useState([]);
  const handleChange = (value) => {
    if (value?.length > 0) {
      const idValue = value[value?.length - 1];
      const selectedOption = materialOptions.find(
        (item) => item.id === idValue,
      );
      if (!!selectedOption) {
        setSelectedTag([idValue]);
        setSelectedMaterialName(selectedOption?.fullMaterialName);
        setValue(MATERIAL_NAME_NAME, selectedOption?.materialValue);
      } else {
        setSelectedTag([idValue]);
        setSelectedMaterialName("");
        setValue(MATERIAL_NAME_NAME, idValue);
      }
    } else {
      setSelectedTag([]);
      setSelectedMaterialName("");
      setValue(MATERIAL_NAME_NAME, null);
    }
  };

  const handleVendorSelectionChange = (value, record) => {
    if (value?.length > 0) {
      if (!!record?.[record?.length - 1]?.value) {
        setVendorSelectedTag([record?.[record?.length - 1]?.value]);
        setSelectedVendorName(record?.[record?.length - 1]?.label);
        setSelectedTag([]);
        setValue(MATERIAL_NAME_NAME, null);
      } else {
        setVendorSelectedTag([value[value?.length - 1]]);
        setSelectedVendorName("");
      }
    } else {
      setVendorSelectedTag([]);
    }
  };
  const checkboxConfig = {
    [CheckboxType.PICKUP]: {
      setState: setPickUpCheckboxState,
      fieldName: PICKUP_LOCATION_NAME,
      fieldCoords: PICKUP_LOCATION_COORDS_NAME,
    },
    [CheckboxType.DELIVERY]: {
      setState: setDeliveryCheckboxState,
      fieldName: DELIVERY_LOCATION_NAME,
      fieldCoords: DELIVERY_LOCATION_COORDS_NAME,
    },
  };

  const handleCheckBox = (checked: boolean, box: CheckboxType) => {
    const { setState, fieldName, fieldCoords } = checkboxConfig[box];
    setState(checked);

    if (checked) {
      const coords = `${presetDropCoordinates?.lat}, ${presetDropCoordinates?.lng}`;
      setValue(fieldName, presetDropLocation);
      setValue(fieldCoords, coords);
      clearErrors(fieldName);
    }
  };

  useEffect(() => {
    refetchMaterialOptions();
  }, [selectedVendorName]);

  return (
    <div>
      <Modal
        visible={isNegativeMarkupModalOpen}
        onCancel={handleNegativeMarkupModalClose}
        onOk={handleNegativeMarkupModalSubmit}
        okText={negativeMarkupModalProps.okButtonLabel}
        cancelText={negativeMarkupModalProps.cancelButtonLabel}
        title={negativeMarkupModalProps.title}
        width={negativeMarkupModalProps.width}
      >
        {negativeMarkupModalProps.content}
      </Modal>
      <Modal
        visible={isWarningModalOpen}
        onCancel={handleCloseWarningModal}
        title="Confirm Cancel"
        okText="Confirm"
        onOk={() => {
          handleCloseWarningModal();
          handleCloseDrawer();
          resetBidToolFormFields();
        }}
      >
        <p style={{ fontSize: "18px" }}>
          If you cancel the edit, all modifications you have made will be lost.
        </p>
      </Modal>

      <Drawer
        visible={isOpen}
        onClose={handleCloseDrawer}
        placement="right"
        width="95%"
        height="100vh"
        closable={false}
        title={
          <div className={styles.HeaderTitleContainer}>
            <div
              className={styles.LeftButtonsContainer}
              onClick={handleCloseDrawer}
            >
              <img src={backButton} alt="back-button" />
              <p>Trucking Bidding Tool</p>
            </div>
            <div className={styles.RightButtonsContainer}>
              <TNButton
                text="Job Map"
                type={ButtonType.PRIMARY}
                shape={ButtonShape.DEFAULT}
                size={ButtonSize.LARGE}
                onClick={() => {
                  const pickupCoords = watch(PICKUP_LOCATION_COORDS_NAME);
                  const pickLat =
                    truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW
                      ? pickupMatCoords.split(",")[1]
                      : String(pickupCoords.split(",")[0]);
                  const pickLng =
                    truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW
                      ? pickupMatCoords.split(",")[0]
                      : String(pickupCoords.split(",")[1]);
                  const deliveryCoords = watch(DELIVERY_LOCATION_COORDS_NAME);
                  const delLat =
                    truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW
                      ? dropOffMatCoords.split(",")[1]
                      : String(deliveryCoords.split(",")[0]);
                  const delLng =
                    truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW
                      ? dropOffMatCoords.split(",")[0]
                      : String(deliveryCoords.split(",")[1]);
                  if (
                    truckFormType === AddTruckType.TRUCK_ADD_FLOW &&
                    (!pickupCoords || !deliveryCoords)
                  ) {
                    message.warning(JOB_MAP_WARNING);
                  } else if (
                    truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW &&
                    (!pickupMatCoords || !dropOffMatCoords)
                  ) {
                    message.error(JOB_MAP_FAILURE);
                  } else
                    return openGoogleMaps({
                      pickUpLat: pickLat,
                      pickUpLng: pickLng,
                      deliveryLat: delLat,
                      deliveryLng: delLng,
                    });
                }}
                customStyles={{
                  backgroundColor: "#1890FF",
                  borderColor: "#1890FF",
                }}
              />
              <TNButton
                text="Cancel"
                type={ButtonType.DEFAULT}
                shape={ButtonShape.DEFAULT}
                size={ButtonSize.LARGE}
                onClick={handleOpenWarningModal}
              />
              <TNButton
                text="Submit"
                type={ButtonType.PRIMARY}
                shape={ButtonShape.DEFAULT}
                size={ButtonSize.LARGE}
                onClick={handleBiddingToolSubmit}
              />
            </div>
          </div>
        }
        headerStyle={DrawerHeaderBidToolStyles}
        size={ButtonSize.LARGE}
        className={styles.truckDetailsFormWrapper}
      >
        <BidToolForm />
      </Drawer>
      <div className={styles.addTruckFormWrapper}>
        <Row>
          <Col span={10}>
            <div className={styles.columnHeaderType}>{TRUCK_TYPE_HEADER}</div>
            <div className={styles.columnValueType}>
              <Row>
                <Col span={23} key={TAB_FIELD_NAME}>
                  <div className={styles.tabWrapper}>
                    <InputField
                      type={InputfieldTypes.SINGLE_OPTION_TAB}
                      name={TAB_FIELD_NAME}
                      tabsOptions={buttonOptionsProps}
                    />
                  </div>
                </Col>
              </Row>
              <div className={styles.truckTypeCheckboxWrapper}>
                {truckDataOptions?.map((item) => (
                  <InputField
                    key={item?.value}
                    type={InputfieldTypes.CHECKBOX}
                    name={item.label}
                    label={item.label}
                    onChange={(val) =>
                      handleCheckChange(item.label, val, item.truckCode)
                    }
                    value={checkboxStates[item.label]}
                  />
                ))}
              </div>
            </div>
          </Col>
          <Col span={14}>
            <div className={styles.rightContainer}>
              <div className={styles.rightTopContainer}>
                <div className={styles.columnHeader}>
                  {truckFormType === AddTruckType.TRUCK_ADD_FLOW
                    ? JOB_DETAILS_HEADER
                    : MATERIAL_DETAILS_HEADER}
                </div>
                <div className={styles.columnFields}>
                  <ConditionalRender
                    visible={truckFormType === AddTruckType.TRUCK_ADD_FLOW}
                  >
                    <div className={styles.topRowWrapper}>
                      <Col span={8}>
                        <TNGoogleAddressSuggestions
                          name={PICKUP_LOCATION_NAME}
                          label={PICKUP_LOCATION_LABEL}
                          requiredField={true}
                          customSize={ButtonSize.MEDIUM}
                          placeholder={PICKUP_LOCATION_PLACEHOLDER}
                          isPickupLocation={true}
                          isTrucking={true}
                        />
                      </Col>
                      <Col span={8}>
                        <InputField
                          type={InputfieldTypes.TEXT}
                          name={PICKUP_LOCATION_COORDS_NAME}
                          label={PICKUP_LOCATION_COORDS_LABEL}
                          requiredField={true}
                          customSize={ButtonSize.MEDIUM}
                          placeholder={PICKUP_LOCATION_PLACEHOLDER}
                          onBlur={async () => {
                            const [lat, lng] = getValues(
                              PICKUP_LOCATION_COORDS_NAME,
                            )?.split(",");
                            setLocLat(lat?.trim());
                            setLocLng(lng?.trim());
                            const { data } = await refetchLocationData();
                            if (data?.data?.formattedAddress) {
                              setValue(
                                PICKUP_LOCATION_NAME,
                                data?.data?.formattedAddress,
                              );
                            }
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <div className={styles.topThirdInputWrapper}>
                          <InputField
                            type={InputfieldTypes.TAG_SELECT}
                            options={vendorOptions}
                            selectLoading={isFetchingMaterialVendors}
                            name={TRUCKING_VENDOR}
                            label={TRUCKING_VENDOR_LABEL}
                            placeholder={TRUCKING_VENDOR_PLACEHOLDER}
                            optionFilterProp={SEARCH_FILTER_TYPE}
                            onSelect={(_, record) => {
                              if (
                                record?.address !== undefined &&
                                record?.lat !== undefined &&
                                record?.lng !== undefined
                              ) {
                                if (
                                  pickUpCheckboxState &&
                                  !deliveryCheckboxState
                                ) {
                                  setValue(
                                    DELIVERY_LOCATION_NAME,
                                    record?.address,
                                  );
                                  setValue(
                                    DELIVERY_LOCATION_COORDS_NAME,
                                    `${record?.lat}, ${record?.lng}`,
                                  );
                                  clearErrors(DELIVERY_LOCATION_NAME);
                                } else {
                                  setValue(
                                    PICKUP_LOCATION_NAME,
                                    record?.address,
                                  );
                                  setValue(
                                    PICKUP_LOCATION_COORDS_NAME,
                                    `${record?.lat}, ${record?.lng}`,
                                  );
                                  clearErrors(PICKUP_LOCATION_NAME);
                                }
                                setValue(TRUCKING_VENDOR, record?.value);
                              }
                            }}
                            onChange={handleVendorSelectionChange}
                            value={vendorSelectedTag}
                          />
                        </div>
                      </Col>
                      <div className={styles.SameCheckboxContainer}>
                        <Checkbox
                          checked={pickUpCheckboxState}
                          onChange={(e) =>
                            handleCheckBox(
                              e.target.checked,
                              CheckboxType.PICKUP,
                            )
                          }
                        >
                          {checkboxConstants.label}
                        </Checkbox>
                      </div>
                      <div className={styles.topRowCords}>
                        <Col span={8}>
                          <TNGoogleAddressSuggestions
                            name={DELIVERY_LOCATION_NAME}
                            label={DELIVERT_LOCATION_LABEL}
                            requiredField={true}
                            customSize={ButtonSize.MEDIUM}
                            placeholder={PICKUP_LOCATION_PLACEHOLDER}
                            isDeliveryLocation={true}
                            isTrucking={true}
                          />
                        </Col>
                        <Col span={8}>
                          <InputField
                            type={InputfieldTypes.TEXT}
                            name={DELIVERY_LOCATION_COORDS_NAME}
                            label={DELIVERY_LOCATION_COORDS_LABEL}
                            requiredField={true}
                            customSize={ButtonSize.MEDIUM}
                            placeholder={PICKUP_LOCATION_PLACEHOLDER}
                            onBlur={async () => {
                              const [lat, lng] = getValues(
                                DELIVERY_LOCATION_COORDS_NAME,
                              )?.split(",");
                              setLocLat(lat?.trim());
                              setLocLng(lng?.trim());
                              const { data } = await refetchLocationData();
                              if (data?.data?.formattedAddress) {
                                setValue(
                                  DELIVERY_LOCATION_NAME,
                                  data?.data?.formattedAddress,
                                );
                              }
                            }}
                          />
                        </Col>
                        <Col span={8}>
                          <InputField
                            type={InputfieldTypes.TAG_SELECT}
                            options={materialDataOptions}
                            name={MATERIAL_NAME_NAME}
                            label={MATERIAL_NAME_LABEL}
                            placeholder={MATERIAL_NAME_PLACEHOLDER}
                            requiredField
                            optionFilterProp={SEARCH_FILTER_TYPE}
                            selectLoading={isFetchingMaterialOptions}
                            onChange={handleChange}
                            value={selectedTag}
                          />
                        </Col>
                        <div className={styles.SameCheckboxContainer}>
                          <Checkbox
                            defaultChecked
                            checked={deliveryCheckboxState}
                            onChange={(e) =>
                              handleCheckBox(
                                e.target.checked,
                                CheckboxType.DELIVERY,
                              )
                            }
                          >
                            {checkboxConstants.label}
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                  </ConditionalRender>
                  <ConditionalRender
                    visible={
                      truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW
                    }
                  >
                    <Col span={7}>
                      <div className={styles.markUpField}>
                        <InputField
                          type={InputfieldTypes.TEXT}
                          name={USE_MARKUP_NAME}
                          label={USE_MARKUP_LABEL}
                          placeholder={USE_MARKUP_PLACEHOLDER}
                          value={useMarkupValue}
                          onBlur={(e) => onBlurHandler(USE_MARKUP_NAME, e)}
                          addonAfter={"%"}
                          onKeyDown={onKeyDownHander}
                        />
                      </div>
                    </Col>
                    <Col span={8}>
                      <InputField
                        type={InputfieldTypes.TEXT}
                        name={MATERIAL_PRICE_NAME}
                        label={MATERIAL_PRICE_LABEL}
                        placeholder={MATERIAL_PRICE_PLACEHOLDER}
                        requiredField
                        value={materialPriceValue}
                        onBlur={(e) => onBlurHandler(MATERIAL_PRICE_NAME, e)}
                        prefix={DOLLAR_PREFIX}
                        addonAfter={selectMaterialAfterFieldProps}
                        onKeyDown={onKeyDownHander}
                      />
                    </Col>
                    <Col span={9}>
                      <InputField
                        type={InputfieldTypes.TEXT}
                        name={MATERIAL_COST_NAME}
                        label={MATERIAL_COST_LABEL}
                        placeholder={MATERIAL_COST_PLACEHOLDER}
                        prefix={DOLLAR_PREFIX}
                        value={materialCostValue}
                        requiredField
                        addonAfter={
                          <span className={styles.disabledUnit}>
                            {venodorMaterialUnit}
                          </span>
                        }
                        onBlur={(e) => onBlurHandler(MATERIAL_COST_NAME, e)}
                        onKeyDown={onKeyDownHander}
                      />
                    </Col>
                  </ConditionalRender>
                </div>
              </div>
              <div className={styles.rightMiddleContainer}>
                <div className={styles.columnHeader}>
                  {ESTIMATED_QUANTITY_HEADER}
                </div>
                <div className={styles.RequiredQuantityFields}>
                  <ConditionalRender
                    visible={
                      truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW
                    }
                  >
                    <Col span={20}>
                      <InputField
                        type={InputfieldTypes.TEXT}
                        name={REQUIRED_MATERIAL_QUANTITY_NAME}
                        label={REQUIRED_MATERIAL_QUANTITY_LABEL}
                        placeholder={REQUIRED_QUANTITY_PLACEHOLDER}
                        onBlur={(e) =>
                          onBlurHandler(REQUIRED_MATERIAL_QUANTITY_NAME, e)
                        }
                        onKeyDown={onKeyDownHander}
                        value={materialQuantityValue}
                        requiredField
                        addonAfter={selectMaterialAfterFieldProps}
                      />
                    </Col>
                  </ConditionalRender>
                  <Col span={20}>
                    <InputField
                      type={InputfieldTypes.TEXT}
                      name={REQUIRED_QUANTITY_NAME}
                      label={REQUIRED_QUANTITY_LABEL}
                      placeholder={REQUIRED_QUANTITY_PLACEHOLDER}
                      onBlur={(e) => onBlurHandler(REQUIRED_QUANTITY_NAME, e)}
                      onKeyDown={onKeyDownHander}
                      value={quantityValue}
                      requiredField
                      addonAfter={selectQuantityAfterFieldProps}
                    />
                  </Col>
                </div>
              </div>
              <div className={styles.rightBottomContainer}>
                <div className={styles.columnHeader}>{TRUCK_PRICE_HEADER}</div>
                <div className={styles.columnFields}>
                  <Col span={10}>
                    <InputField
                      type={InputfieldTypes.TEXT}
                      name={TRUCK_PRICE_NAME}
                      label={TRUCK_PRICE_LABEL}
                      placeholder={TRUCK_PRICE_PLACEHOLDER}
                      requiredField
                      value={truckingPriceValue}
                      addonAfter={selectQuantityAfterFieldProps}
                      prefix={`$`}
                      onBlur={(e) => onBlurHandler(TRUCK_PRICE_NAME, e)}
                      onKeyDown={onKeyDownHander}
                    />
                  </Col>
                  <Col span={10}>
                    <InputField
                      type={InputfieldTypes.TEXT}
                      name={TRUCK_COST_NAME}
                      label={TRUCK_COST_LABEL}
                      placeholder={TRUCK_COST_PLACEHOLDER}
                      onBlur={(e) => onBlurHandler(TRUCK_COST_NAME, e)}
                      value={truckingCostValue}
                      requiredField
                      addonAfter={
                        <span className={styles.disabledUnit}>
                          {selectedQuantityUnit}
                        </span>
                      }
                      disabled
                      prefix={`$`}
                      onKeyDown={onKeyDownHander}
                    />
                  </Col>
                  <Col span={4}>
                    <div className={styles.buttonToolWrapper}>
                      <TNButton
                        shape={ButtonShape.DEFAULT}
                        size={ButtonSize.LARGE}
                        text={BID_TOOL_BTN_TEXT}
                        onClick={handleOpenDrawer}
                        customStyles={BidToolStyles}
                      />
                    </div>
                  </Col>
                  <Col span={10} className={styles.MinimumHoursInput}>
                    <InputField
                      type={InputfieldTypes.TEXT}
                      name={MINIMUM_HOURS_NAME}
                      label={MINIMUM_HOURS_LABEL}
                      placeholder={MINIMUM_HOURS_PLACEHOLDER}
                      disabled={selectedQuantityUnit !== HOUR_TXT}
                      value={minimumHoursValue}
                      onBlur={(e) => onBlurHandler(MINIMUM_HOURS_NAME, e)}
                      onKeyDown={onKeyDownHander}
                    />
                  </Col>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className={styles.projectSummaryWrapper}>
              <Row>
                <div className={styles.columnProjectHeader}>
                  {PROJECT_SUMMARY_HEADER}
                </div>
              </Row>
              <div className={styles.tableBodyHeaderWrapper}>
                <Row>
                  <Col span={4}></Col>
                  {sampleProjectSummaryHeader?.map((header, index) => (
                    <Col span={4} key={index}>
                      <div className={styles.tableBodyHeaderValues}>
                        {header}
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
              <ConditionalRender
                visible={truckFormType === AddTruckType.TRUCK_ADD_FLOW}
              >
                {" "}
                {projectSummaryContents?.map(
                  ([label, value1, value2, value3], rowIndex) => (
                    <div className={styles.tableBodyWrapper} key={rowIndex}>
                      <Row>
                        <Col span={4}>
                          <div className={styles.tableColumnHeaderValues}>
                            {label}
                          </div>
                        </Col>
                        {[value1, value2, value3].map((value, colIndex) => (
                          <Col span={4} key={colIndex}>
                            <div className={styles.tableNumericValues}>
                              {colIndex === 2
                                ? getPostPercentFormattedString(value)
                                : getPrevDollorFormattedString(value)}
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ),
                )}
              </ConditionalRender>
              <ConditionalRender
                visible={truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW}
              >
                {projectSummaryContentsMaterial?.map(
                  ([label, value1, value2, value3], rowIndex) => (
                    <div className={styles.tableBodyWrapper} key={rowIndex}>
                      <Row>
                        <Col span={4}>
                          <div
                            className={clsx({
                              [styles.tableNumericValues]: [0, 3, 6].includes(
                                rowIndex,
                              ),
                              [styles.tableColumnHeaderValues]: ![
                                0, 3, 6,
                              ].includes(rowIndex),
                            })}
                          >
                            {label}
                          </div>
                        </Col>
                        {[value1, value2, value3].map((value, colIndex) => (
                          <Col span={4} key={colIndex}>
                            <div
                              className={clsx({
                                [styles.tableNumericValues]: [0, 3, 6].includes(
                                  rowIndex,
                                ),
                                [styles.tableColumnHeaderValues]: ![
                                  0, 3, 6,
                                ].includes(rowIndex),
                              })}
                            >
                              {colIndex === 2
                                ? getPostPercentFormattedString(value)
                                : getPrevDollorFormattedString(value)}
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ),
                )}
              </ConditionalRender>
            </div>
          </Col>
        </Row>
        <Row>
          <div className={styles.buttonWrapper}>
            <ConditionalRender
              visible={truckFormType === AddTruckType.MATERIAL_VENDOR_FLOW}
            >
              <TNButton
                shape={ButtonShape.DEFAULT}
                size={ButtonSize.LARGE}
                text={CANCEL_BTN_TXT}
                onClick={handleVendorFormResetClose}
                customStyles={CancelStyles}
              />
              <TNButton
                shape={ButtonShape.DEFAULT}
                size={ButtonSize.LARGE}
                text={SUBMIT_BTN_TXT}
                onClick={handleSubmit(
                  handleMaterialVendorSubmit,
                  handleAddVendorValidationErrors,
                )}
                customStyles={SubmitStyles}
              />
            </ConditionalRender>
            <ConditionalRender
              visible={truckFormType === AddTruckType.TRUCK_ADD_FLOW}
            >
              <TNButton
                shape={ButtonShape.DEFAULT}
                size={ButtonSize.LARGE}
                text={CANCEL_BTN_TXT}
                onClick={handleAddFormResetClose}
                customStyles={CancelStyles}
              />
              <TNButton
                shape={ButtonShape.DEFAULT}
                size={ButtonSize.LARGE}
                text={SUBMIT_BTN_TXT}
                onClick={handleSubmit(
                  handleFormSubmit,
                  handleAddValidationErrors,
                )}
                customStyles={SubmitStyles}
              />
            </ConditionalRender>
          </div>
        </Row>
      </div>
    </div>
  );
};
export default AddTruckOrdersForm;
